var exports = {
  "c": "StatusIndicator.module__displayBlock___T1ZxdU",
};

module.exports = exports;
